// @flow

import React, {type Node} from 'react';
import styled from 'styled-components';
import cs from 'classnames';

import {colors} from 'js-libs/sweetcommons/styles';

const BorderContainerDiv = styled.div`
  margin-left: ${({small}) => (small ? '1' : '1.4')}rem;
  padding-left: ${({small}) => (small ? '1' : '1.4')}rem;
  border-left: 3px solid ${colors.lightGray};
`;

type Props = {
  collapsed: boolean,
  buttonText: Node,
  small: boolean,
  children: Node,
  onToggleCollapse?: (boolean) => void,
};

type State = {
  collapsed: boolean,
};

export class CollapsableButtonArea extends React.PureComponent<Props, State> {
  static defaultProps = {
    collapsed: true,
    small: false,
  };

  constructor(props: Props) {
    super(props);
    this.state = {collapsed: props.collapsed};

    if (this.props.onToggleCollapse != null) {
      this.props.onToggleCollapse(this.state.collapsed);
    }
  }

  toggleCollapsed = () => {
    const collapsed = !this.state.collapsed;
    this.setState({collapsed});

    if (this.props.onToggleCollapse != null) {
      this.props.onToggleCollapse(collapsed);
    }
  };

  render() {
    const {small, buttonText, children} = this.props;
    const {collapsed} = this.state;

    return (
      <div>
        <p className="mt-3">
          <button
            className={cs('btn btn-light', {
              active: !collapsed,
              'btn-sm': small,
            })}
            onClick={this.toggleCollapsed}
            type="button"
          >
            <i
              className={`fa fa-fw fa-chevron-${collapsed ? 'right' : 'down'}`}
            />{' '}
            {buttonText}
          </button>
        </p>
        {collapsed ? null : (
          <BorderContainerDiv small={small} className="mb-4">
            {children}
          </BorderContainerDiv>
        )}
      </div>
    );
  }
}
